"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.login = void 0;
const auth_1 = require("../shared/auth");
const config_1 = require("../shared/config");
const query_string_1 = require("query-string");
function login() {
  (0, config_1.readConfig)("/external-login/aad-config").then(config => {
    const authClient = new auth_1.Auth(config.clientid, config.tenantid, config.redirectPathSignIn, config.oauthScopes);
    const {
      requestedUri
    } = query_string_1.default.parse(window.location.search.slice(1));
    const requestedUriFlattend = Array.isArray(requestedUri) ? requestedUri[0] : requestedUri;
    authClient.loginWithRedirect(requestedUriFlattend || undefined);
  });
}
exports.login = login;
window.addEventListener("load", async () => {
  login();
});
//# sourceMappingURL=index.js.map